import React, { useEffect, useState } from "react";
import { Layout, Button, Card, Row, Col } from "antd";
import UnShippingOrders from "./UnShippedOrders";
import PackedOrders from "./PackedOrder";
import EcomShipment from "./EcomShipment";
import AdminUnShiipingOrder from "./AdminUnShippedOrder";
import AdminPackedOrder from "./AdminPackedOrder";
import AdminEcomShipment from "./AdminEcomShipmentOrders";
import ReturnOrders from "./ReturnOrders";
import "./Styles/staffManagement.css"; // Assuming you have a CSS file for styling

const { Content } = Layout;

const OrdersManagement = () => {
  const [activeTab, setActiveTab] = useState("un - ship");
  const [role, setRole] = useState(null);

  useEffect(() => {
    const Role = localStorage.getItem("role");
    console.log(Role);
    setRole(Role);
  }, []);

  return (
    <Layout className="admin-dashboard-layout">
      {/* <Content className="admin-dashboard-content"> */}
      <Card title="Order Management" className="admin-dashboard-card">
        <Row gutter={[16, 16]} justify="space-between">
          <Col xs={24} sm={6} style={{ paddingBottom: 20 }}>
            <Button
              type={activeTab === "un - ship" ? "primary" : "default"}
              onClick={() => setActiveTab("un - ship")}
              block
            >
              Un - Shipping Orders
            </Button>
          </Col>
          <Col xs={24} sm={6}>
            <Button
              type={activeTab === "packed" ? "primary" : "default"}
              onClick={() => setActiveTab("packed")}
              block
            >
              Packed Orders
            </Button>
          </Col>
          <Col xs={24} sm={6}>
            <Button
              type={activeTab === "ecom" ? "primary" : "default"}
              onClick={() => setActiveTab("ecom")}
              block
            >
              E-Com Shipment
            </Button>
          </Col>
          {role === "admin" ? (
            <Col xs={24} sm={6}>
              <Button
                type={activeTab === "return" ? "primary" : "default"}
                onClick={() => setActiveTab("return")}
                block
              >
                Return Orders
              </Button>
            </Col>
          ) : (
            " "
          )}
        </Row>
        {activeTab === "un - ship" &&
          (role === "admin" ? <AdminUnShiipingOrder /> : <UnShippingOrders />)}
        {activeTab === "packed" &&
          (role === "admin" ? <AdminPackedOrder /> : <PackedOrders />)}
        {activeTab === "ecom" &&
          (role === "admin" ? <AdminEcomShipment /> : <EcomShipment />)}
        {activeTab === "return" && (role === "admin" ? <ReturnOrders /> : " ")}
      </Card>
      {/* </Content> */}
    </Layout>
  );
};

export default OrdersManagement;
